import { render, staticRenderFns } from "./QuestionFilter.vue?vue&type=template&id=4188421c"
import script from "./QuestionFilter.vue?vue&type=script&lang=ts"
export * from "./QuestionFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports